.wrapper {
  background-color: var(--global-color-gray-50);
  border-radius: var(--border-radius-sm);
  margin-left: calc(-1 * var(--space-2xs));
  padding: var(--space-3xs) var(--space-2xs);
}

.helpText {
  color: var(--color-text-subtle);
  pointer-events: none;
  user-select: none;
}

.mention {
  color: var(--color-link-enabled);
}

.spinner {
  margin-bottom: -3px;
}

.suggestionsPopover {
  max-height: 288px;
  max-width: 260px;
  overflow: auto;
  padding: var(--space-sm) var(--space-xs);

  /* Nothing renders inside while a fetch is in flight (too-short query message,
     not-found message, and results are all mutually exclusive with "loading") —
     without this the popover still floats as an empty box next to the inline spinner. */
  &:empty {
    display: none;
  }
}

.list {
  display: flex;
  flex-direction: column;
}

.item {
  border-radius: var(--border-radius-sm);
  color: var(--color-text-neutral);
  cursor: pointer;
  margin-bottom: var(--space-2xs);
  padding: var(--space-xs);

  &:last-child {
    margin-bottom: 0;
  }
}

.info {
  border-radius: var(--border-radius-sm);
  text-align: center;
}

.infoText {
  color: var(--color-text-subtle);
}
